import { render, staticRenderFns } from "./BdTableAndroid.vue?vue&type=template&id=4adc0d30&scoped=true&"
import script from "./BdTableAndroid.vue?vue&type=script&lang=js&"
export * from "./BdTableAndroid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adc0d30",
  null
  
)

export default component.exports